import { HtmlBlock } from '@/cms/definitions/content-types';
import Coverage from './components/coverageComponent/Coverage';
import InsurancesProductEnum from '@/enums/InsurancesProductEnum';
import { isDevelop } from '@/views/calculators/services/environmentService';
import store from '@/store/store';
import { exception, information } from '@/appinsights/logging/ApplicationInsightLog';
import { almbrandOnlineCampaignName, upSaleCampaignName } from './services/campaignService';
import AxiosService from './services/axiosService';
import { AxiosResponse } from 'axios';
import { defaultConfig } from '@/cms/api/ApiConfig';

export interface Street {
	name: string;
	nos?: string[];
}
export interface AddressBlock {
	zipCity: string;
	streets: Array<Street>;
}

export interface AddressSearch {
	houseNr: string;
	streetName: string;
	zipCode: string;
	zipName: string;
}
type PropType<TObj, TProp extends keyof TObj> = TObj[TProp];

export default class BuyInsuranceSettings {
	// settings from CMS
	public waitForEmail = 0;
	public initialTimeout = 500;
	public animationTimeout = 1250;
	public animationTimeoutBuy = 1500;
	public personDataLink = '/kundeservice/generel-information/vi-passer-paa-dine-persondata/';
	public defaultCard: string;
	public dataGtm = 'button-click';
	public btnStyle = 'btn-solid-secondary';
	public btnLabel = 'Ok';
	public failText =
		'Men vi har dygtige medarbejdere siddende klar ved telefonerne, til at hjælpe dig videre. Klik på "Ring 96101713", for at blive stillet direkte om.';
	public btnSecondStyle = 'btn-outline-secondary';
	public btnSecondLabel = 'Ok';
	public failTitle = '<br/>Vi kan desværre ikke give dig en pris online';
	public contactTitle = 'Kontakt os';
	public contactText: string;
	public contactHideOnReceipt = false;
	public contactCanCall = true;
	public contactCanWrite = true;
	public contactCompleteOffer = true;
	public contactDirectMail: string;
	public contactMailTo: string;
	public questionTitle = 'Hjælp til køb af forsikringer';
	public ratePopover: string = undefined;
	public rkiHeader = 'Er du registreret i RKI';
	public rkiPopover: string = undefined;
	public rkiPopupTitle: string = undefined;
	public rkiPopupContent: string = undefined;
	public damagesPopupTitle: string = undefined;
	public damagesPopupContent: string = undefined;
	public damagesOk: string[] = ['0', '1', '2'];
	public createOnlineQuote = false;
	public open = '08.00, 15.30, 1.2.3.4.5';
	public closingDays: string[] = ['12-24', '12-31'];
	public paymentBox =
		'Din betaling starter først den dag forsikringen træder i kraft.<br><br>Du har 14-dages fuld fortrydelsesret.';
	public insuranceCompanies: string[] = [];
	public insuranceCompaniesIds: string[] = [];
	public ipidText: string;
	public ipidLink: string;
	public conditionsText: string;
	public conditionsLink: string;
	public ipidText1: string;
	public ipidLink1: string;
	public conditionsText1: string;
	public conditionsLink1: string;
	public ieBrowserContent =
		'Vi understøtter desværre ikke den browser du bruger. For at få siden til at virke, anbefaler vi at du i stedet åbner den i Google Chrome, Microsoft Edge eller lignende.';
	public ieBrowserTitle = 'Ældre browser';
	public samletTilbudLink: string; //'/landingpages/bestil-samlet-tilbud/';
	public samletTilbudText: string; // = 'Brug for flere forsikringer - gå til samlet tilbud';
	public defaultCalcErrorTitle = 'Der er desværre sket en fejl';
	public defaultCalcErrorContent =
		'Der er desværre sket en uforudset fejl. Prøv evt. at indtaste oplysninger igen eller kontakt Alm. Brand';
	public yearlySavings: string = undefined;
	public existingInsuranceText = 'Har du en eksisterende forsikring, som vi skal opsige for dig?';
	public minCustomerAge = 18;
	public customerAgePopupTitle: string = undefined;
	public customerAgePopupContent: string = undefined;
	public customerAgePopupRedirect: string = undefined;

	public calculatedHeadline = 'Valgt pakke';
	public closeCalculator = false;
	public closeCalculatorPopupTitle: string;
	public closeCalculatorPopupContent: string;
	public btnLabelClose: string;
	public btnSecondLabelClose: string;
	public btnSecondLabelCloseStyle: string;
	public btnRedirectClose: boolean;
	public btnRedirectUrlClose: string;
	public btnCallMeUpEnabled: boolean;
	public recommendationTxt: string;
	public recommendationPackage: string;
	public recommendationPopover: string;
	public AllCalculationProducts: string[] = [
		'indboforsikring',
		'husforsikring',
		'fritidshusforsikring',
		'ulykkesforsikring',
		'rejseforsikring',
		'bilforsikring',
		'hundeforsikring',
		'børneulykkesforsikring',
		'børnefamilieforsikring',
	];
	public discountProducts: string[] = [
		'Indboforsikring',
		'Husforsikring',
		'Fritidshusforsikring',
		'Ulykkesforsikring',
		'Rejseforsikring',
		'Bilforsikring',
		'Motorcykelforsikring',
		'Veterankøretøjsforsikring',
		'Campingvognforsikring',
		'Hesteforsikring',
		'Hundeforsikring',
	];
	public discountPrimaryProducts: string[] = ['Indboforsikring'];
	public discountSecondaryProducts: string[] = [
		'Husforsikring',
		'Fritidshusforsikring',
		'Ulykkesforsikring',
		'Bilforsikring',
	];
	public discountTernaryProducts: string[] = [
		'Husforsikring',
		'Fritidshusforsikring',
		'Ulykkesforsikring',
		'Rejseforsikring',
		'Bilforsikring',
		'Motorcykelforsikring',
		'Veterankøretøjsforsikring',
		'Campingvognforsikring',
		'Hesteforsikring',
		'Hundeforsikring',
	];
	public discountProductNone = 'Ingen af disse forsikringer';
	public validCampaigns: string[] = [];
	private campaignsRaw: string;
	public campaigns: Map<string, any> = new Map();
	private campaignSplash: string;
	private campaignSplashIcons: string;

	private campaignSplashDependentActive: boolean; // value set in store on load
	private campaignSplashDependentProducts: string[] = []; // value set in store on load
	private campaignSplashMinProductsBasket = 0; // value set in store on load
	public campaignSplashAlertTitle: string;
	public campaignSplashAlertContent: string;
	public campaignSplashAlertTitleActivate: string;
	public campaignSplashAlertContentActivate: string;

	public plusCustomerNoDiscount: string;
	public plusCustomerNoDiscountNoCampaignDiscount: string;
	public plusCustomerDiscount: string;
	public plusCustomerPopover: string;
	public calculationInvalid: string;
	public calculationNotDone: string;
	public showBasket = true;
	public addProductsTxt = 'Tilføj forsikringer';
	public btnInlineLabel: string;
	public btnInlineStyle = 'btn-outline-secondary mt-3 mb-3';

	public useBtnInlineFail: boolean;
	public btnInlineFailLabel: string; //'Prøv igen',
	public btnInlineFailStyle: string; //'btn-outline-primary mt-3 mb-3',
	public btnInlineIcon: string;

	public selvrisikoLabel: string;
	public packageSubheader: string;
	public coverageGroups: string;
	public coverageGroupDescriptions: string;
	public coverageGroupsSubFeatures: string;
	public plusCustomerCalculation = false;
	public mockData = false;
	public suggestTextMiniBasket = true;
	public miniBasketDiscountPreTxt = '<br/><span><i>Plus</i>Kunde rabat <strong><em>';
	public miniBasketDiscountPostTxt = '</em></strong></span>';
	public suggestProductsText: string;
	public suggestProductsText1: string;
	public extendCoverages = false;
	public campaignStoreValidMillis: number = 1000 * 60 * 30; // default 30 min
	public overviewShowYearlyPrice = false;
	public tryLoadCustomer = false;
	public receiptOpenTxt: string;
	public receiptClosedTxt: string;
	public receiptOneTxt: string;
	public receiptBasketTxt: string;
	public receiptOpenMissingProduct: string;
	public receiptClosedMissingProduct: string;
	public receiptTxtEnd: string;
	public mailConfirmationToTeam: boolean;
	public badge: string;
	public callupAddressesPopupTitle: string;
	public callupAddressesPopupContent: string;
	public queryProductNames: string[] = [];
	public queryProductValues: string[] = [];
	public addressSupplement = 1;
	public shortTitle = '';
	public shortMainTitle = 'Beregn pris';
	public wrongAddressPopuptitle = 'Adresse oplysninger stemmer ikke overens';
	public wrongAddressPopupContent =
		'Dine adresse oplysninger passer ikke overens med tidligere indtastning<br><strong>@zipTxt</strong>';
	public hasGlobalMessage = false;
	public globalMessageTxt =
		'<h2>Der kan forekomme driftforstyrrelser</h2>Da vi er ved at opdatere vores systemer, kan der forekomme udfald.<br> Hvis du oplever problemer, så prøv venligst igen lidt senere.<br><br>Vi beklager ulejligheden';
	public globalMessageDate = '15-2';
	public globalMessageFrom = '13:00';
	public globalMessageTo = '13:59';
	public globalMessageTimeout = 2000;
	public globalMessageMultipleDates = [];
	public useLocalStorage = false;
	public openForCall: string;
	public closingDaysForCall: string[] = [];
	public contactTextNoCall: string;
	public calculatorConfigId: string;
	public sendLeadMail: boolean;
	public phoneNoPopOver: string;
	public selvrisikoPopover: string;
	public useNewPolicyAPI: boolean;
	public logToAppUiTest: boolean;
	public customerAddressRequired: boolean;
	public showYearlyPrices = false;
	public regNoPopover: string;
	public accountNoPopover: string;
	public skipAccountInfo = false;

	// upSale campaign
	public campaignProductsUpSale: string[] = [];
	public multiplePkStartBtnUpSale: string;
	public upsaleShowProductsAfterPK3: boolean;
	public showUpsaleDetailBlock: boolean;
	public mainTxtUpSale: string;
	public mainTxtUpSaleMoreDiscount: string;
	public txtProductUpSale: string;
	public productAmountTxtUpSale: string;
	public singleProductTxtUpSale: string; // +{{existingDiscountAddOn}}
	public productTotalAmountTxtUpSale: string;
	public productTotalAmountNumberUpSale: string;
	public toggleTitleClosedUpSale: string;
	public toggleTitleOpenUpSale: string;
	public btnLabelUpSale: string;
	public notCalculatedUpSaleProduct: string;
	public secondarySuggestOrderUpSale: string[] = [];
	public upsaleAlertDiscountTitle: string;
	public upsaleAlertDiscountContent: string;

	public consentCprText: string;
	public consentTextNoCompany: string;
	public consentText: string;
	public consentLinkText: string;
	public consentDetailsText: string;

	public focusFirstFieldDesktop: boolean;

	public updateExcessListFromProductCalculation: boolean;

	public submitFailPopup = false;
	public submitTitleFail = '<br/>Fejl i oprettelse af tilbud';
	public submitFailContent =
		'Der er desværre sket en fejl i oprettelsen af dit tilbud. Prøv venligst igen, eller kontakt os på tlf. <a href="tel:96101713">96101713</a> eller på email <a href="mailto:Ekundeservice@almbrand.dk">Ekundeservice@almbrand.dk</a>.<br/><br/>Vi beklager ulejligheden.';

	// set on load
	public focusFirstField: boolean;

	// set on load
	public coveragesCmsText: Map<string, string>;
	public callUpAddressesBlocks: Array<AddressBlock> = [];
	public sendProposalToEmail = true;
	public useSalesForceQuoteApi = false;
	public sendProposalToSalesForce = false;
	public salesForceTimeout = 15000;
	public salesForceTestUri = '';
	public salesForceTestEnvironmentHeader: string;

	public coverageGrouping: Map<string, Array<string>>;
	public allSubFeatures: string[];

	public settingsBlock: HtmlBlock;

	public constructor(settingsBlock: HtmlBlock) {
		this.settingsBlock = settingsBlock;

		// when OSS is in problem answering phones, wee need to replace their phone no with customerService no
		this.mapOssPhoneNoToCustomerServiceNo();

		this.loadSettings();
		this.mapCampaigns();
		this.setCoverageGroups();

		if (this.campaignSplashDependentActive) {
			store.state.campaignSplashDependentActive = true;
			store.state.campaignSplashDependentProducts = this.campaignSplashDependentProducts;
			store.state.campaignSplashMinProductsBasket = this.campaignSplashMinProductsBasket;
		}

		this.lazyLoad();
	}

	private lazyLoad() {
		// async
		this.loadInsuranceCompanies();
	}

	private async loadInsuranceCompanies() {
		if (store.state.insuranceCompanies.length > 0) {
			// insuranceCompanies already fetched
			this.insuranceCompanies = store.state.insuranceCompanies;
			this.insuranceCompaniesIds = store.state.insuranceCompanyIds;
			return;
		}
		try {
			const axiosService = new AxiosService();
			const res: AxiosResponse = await axiosService.get(
				defaultConfig.baseUrl + store.state.openServiceCalculatorUrl + '/quote-accept/insurance-companies'
			);
			if (res?.data?.insurance_companies?.length > 0) {
				const sortedCompanies = res.data.insurance_companies;
				sortedCompanies.sort((a, b) => a.company_name.localeCompare(b.company_name));
				const opts = [];
				const ids = [];
				sortedCompanies.forEach((elem) => {
					opts.push(elem.company_name);
					ids.push(elem.vir_number ?? elem.company_id);
				});
				this.insuranceCompanies = opts;
				this.insuranceCompaniesIds = ids;
			}
		} catch (e) {
			exception(e);
		}
		store.state.insuranceCompanies = this.insuranceCompanies;
		store.state.insuranceCompanyIds = this.insuranceCompaniesIds;
	}

	public mapOssPhoneNoToCustomerServiceNo() {
		try {
			const replacePhoneNo = this.settingsBlock.markup
				.toLowerCase()
				.includes('replaceossphonenowithcustomerservice=true');
			if (replacePhoneNo) {
				this.settingsBlock.markup = this.settingsBlock.markup.replaceAll('96101713', '96101717');
				this.settingsBlock.markup = this.settingsBlock.markup.replaceAll('96 10 17 13', '96 10 17 17');
			}
		} catch (e) {
			// too bad
		}
	}

	// get productList for discount, excluding current product
	public getDiscountProducts(basket: string[]): string[] {
		const remove = [];
		if (basket.includes(InsurancesProductEnum.BOERNE_FAMILIE_FORSIKRING)) {
			// remove indbo og ulykke
			remove.push(InsurancesProductEnum.INDBO_FORSIKRING, InsurancesProductEnum.ULYKKES_FORSIKRING);
		}

		if (
			(basket.includes(InsurancesProductEnum.INDBO_FORSIKRING) &&
				basket.includes(InsurancesProductEnum.ULYKKES_FORSIKRING)) ||
			basket.includes(InsurancesProductEnum.BOERNEULYKKES_FORSIKRING)
		) {
			remove.push(InsurancesProductEnum.BOERNE_FAMILIE_FORSIKRING);
		}

		if (basket.includes(InsurancesProductEnum.BOERNEULYKKES_FORSIKRING)) {
			remove.push(InsurancesProductEnum.ULYKKES_FORSIKRING);
		}
		const products = this.discountProducts.filter((insurance) => {
			const product = insurance.toLocaleLowerCase();
			if (remove.includes(product)) {
				return false;
			}
			if (basket.includes(product)) {
				return false;
			}
			return true;
		});
		products.push(this.discountProductNone);
		return products;
	}

	public getCoverageName(name: string) {
		if (!name) {
			return undefined;
		}
		if (!this.coveragesCmsText) {
			return name;
		}
		const n = name.toLocaleLowerCase();
		const res = this.coveragesCmsText.get(n);
		return res ?? name;
	}
	public getCoverageDescription(name: string, defaultDescription: string) {
		if (!this.coveragesCmsText) {
			return defaultDescription;
		}
		const n = name.toLocaleLowerCase() + '_beskrivelse';
		const res = this.coveragesCmsText.get(n);
		return res ?? defaultDescription;
	}

	/**Map campaigns */
	private mapCampaigns(): void {
		if (this.campaignsRaw) {
			const campaigns: string[] = this.campaignsRaw.toLocaleUpperCase().split('¤');
			if (campaigns.length > 0) {
				this.validCampaigns = [];
				this.campaigns = new Map();
				campaigns.map((agreement) => agreement.trim());
				campaigns.forEach((agreement_) => {
					const block = agreement_.split('|').map((elem) => elem.trim());
					const campaignId = block[0].toLocaleLowerCase(); // eks. diba
					const campaign = {
						groupId: Number.parseInt(block[1]),
						blockId: block[2],
						discount: Number.parseFloat(block[3]),
						includeDiscountPlusCustomer: block[4] === 'TRUE',
						description: block[5].toLocaleLowerCase(),
						tiaDiscount: block.length > 6 ? Number.parseFloat(block[6]) : 0,
						productStepDiscount:
							block.length > 7 ? block[7].split(',').map((x) => Number.parseFloat(x.trim())) : undefined,
						splash: undefined,
						splashIcons: undefined,
					};
					// DEBUG campaign.productStepDiscount =
					// 	DEBUG campaign.productStepDiscount.length > 1 ? campaign.productStepDiscount : undefined;
					this.validCampaigns.push(campaignId);
					this.campaigns.set(campaignId, campaign);

					// splash txt
					if (this.campaignSplash) {
						const campaignSplash: string[] = this.campaignSplash.split('¤');
						const splashObj: Map<string, string> = new Map();
						campaignSplash.forEach((splash) => {
							if (splash.toLocaleLowerCase().includes(campaignId)) {
								const elem = splash.replace(campaignId.toLocaleUpperCase() + '|', '');
								const splashElem = elem.split('|');
								splashObj.set(splashElem[0], splashElem[1]);
							}
						});
						if (splashObj.size > 0) {
							campaign.splash = splashObj;
							// splash ikons
							if (this.campaignSplashIcons) {
								const campaignSplashIcons: string[] = this.campaignSplashIcons.split('¤');
								const splashIconObj: Map<string, string> = new Map();
								campaignSplashIcons.forEach((icon) => {
									if (icon.toLocaleLowerCase().includes(campaignId)) {
										const elem = icon.replace(campaignId.toLocaleUpperCase() + '|', '');
										const splashElem = elem.split('|');
										splashIconObj.set(splashElem[0], splashElem[1]);
									}
								});
								if (splashIconObj.size > 0) {
									campaign.splashIcons = splashIconObj;
								}
							}
						}
					}
				});

				// add upsale campaign as a near copy of almbrandonline except from campaign description
				const abOnline = this.campaigns?.get(almbrandOnlineCampaignName);
				if (abOnline) {
					const upsale = { ...abOnline };
					upsale.description = upSaleCampaignName + ' - ' + upsale.description;
					this.campaigns.set(upSaleCampaignName, upsale);
					this.validCampaigns.push(upSaleCampaignName);
				}
			}
		}
		// DEBUG console.log('campaigns', this.campaigns);
	}

	/**
	 * load settings from CMS if present
	 */

	private loadSettings() {
		try {
			let setting: string;
			const settingsArr = this.settingsBlock.markup.split('$');

			// DEBUG const properties = Object.getOwnPropertyNames(this);
			// DEBUG console.log('setting properties', properties);
			// DEBUG properties.forEach((prop) => {
			// DEBUG 	const property = prop.toLocaleUpperCase() + '=';
			// DEBUG 	console.log(prop, typeof this[prop]);

			// DEBUG // getTypeofProperty(this,prop)
			// DEBUG });

			settingsArr.forEach((setting_) => {
				setting = setting_.toLowerCase().trim();
				if (setting.startsWith('animationtimeout=')) {
					const timeout = Number.parseInt(this.getSettingsValue(setting_));
					this.animationTimeout = timeout;
				} else if (setting.startsWith('persondatalink=')) {
					this.personDataLink = this.getSettingsValue(setting_);
				} else if (setting.startsWith('initialtimeout=')) {
					const timeout = Number.parseInt(this.getSettingsValue(setting_));
					this.initialTimeout = timeout;
				} else if (setting.startsWith('waitforemail=')) {
					this.waitForEmail = Number.parseInt(this.getSettingsValue(setting_));
				} else if (setting.startsWith('animationtimeoutbuy=')) {
					const timeout = Number.parseInt(this.getSettingsValue(setting_));
					this.animationTimeoutBuy = timeout;
				} else if (setting.startsWith('defaultcard=')) {
					this.defaultCard = this.getSettingsValue(setting_);
				} else if (setting.startsWith('data-gtm=')) {
					this.dataGtm = this.getSettingsValue(setting_);
				} else if (setting.startsWith('failtext=')) {
					this.failText = this.getSettingsValue(setting_);
				} else if (setting.startsWith('btnstyle=')) {
					this.btnStyle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('btnlabel=')) {
					this.btnLabel = this.getSettingsValue(setting_);
				} else if (setting.startsWith('btnsecondstyle=')) {
					this.btnSecondStyle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('btnsecondlabel=')) {
					this.btnSecondLabel = this.getSettingsValue(setting_);
				} else if (setting.startsWith('failtitle=')) {
					this.failTitle = this.getSettingsValue(setting_);
					//submitFailPopup
				} else if (setting.startsWith('submitfailpopup=')) {
					this.submitFailPopup = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('submittitlefail=')) {
					this.submitTitleFail = this.getSettingsValue(setting_);
				} else if (setting.startsWith('submitfailcontent=')) {
					this.submitFailContent = this.getSettingsValue(setting_);
					//END submitFailPopup
				} else if (setting.startsWith('contacttitle=')) {
					this.contactTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('contacttext=')) {
					this.contactText = this.getSettingsValue(setting_);
				} else if (setting.startsWith('contacthideonreceipt=')) {
					this.contactHideOnReceipt = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('contactcancall=')) {
					this.contactCanCall = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('contactcanwrite=')) {
					this.contactCanWrite = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('contactcompleteoffer=')) {
					this.contactCompleteOffer = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('contactdirectmail=')) {
					this.contactDirectMail = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('contactmailto=')) {
					this.contactMailTo = this.getSettingsValue(setting_);
				} else if (setting.startsWith('questiontitle=')) {
					this.questionTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('ratepopover=')) {
					this.ratePopover = this.getSettingsValue(setting_);
				} else if (setting.startsWith('rkiheader=')) {
					this.rkiHeader = this.getSettingsValue(setting_);
				} else if (setting.startsWith('rkipopover=')) {
					this.rkiPopover = this.getSettingsValue(setting_);
				} else if (setting.startsWith('rkipopuptitle=')) {
					this.rkiPopupTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('rkipopupcontent=')) {
					this.rkiPopupContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('damagespopuptitle=')) {
					this.damagesPopupTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('damagespopupcontent=')) {
					this.damagesPopupContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('damagesok=')) {
					const damages = this.getSettingsValue(setting_);
					this.damagesOk = damages.split('¤');
				} else if (setting.startsWith('createonlinequote=')) {
					const onlineQuote = JSON.parse(this.getSettingsValue(setting_));
					this.createOnlineQuote = onlineQuote;
				} else if (setting.startsWith('open=')) {
					this.open = this.getSettingsValue(setting_);
				} else if (setting.startsWith('closingdays=')) {
					this.closingDays = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('paymentbox=')) {
					this.paymentBox = this.getSettingsValue(setting_);
				} else if (setting.startsWith('insurancecompanies=')) {
					this.insuranceCompanies = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('insurancecompaniesids=')) {
					this.insuranceCompaniesIds = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('ipidtext=')) {
					this.ipidText = this.getSettingsValue(setting_);
				} else if (setting.startsWith('ipidlink=')) {
					this.ipidLink = this.getSettingsValue(setting_);
				} else if (setting.startsWith('conditionstext=')) {
					this.conditionsText = this.getSettingsValue(setting_);
				} else if (setting.startsWith('conditionslink=')) {
					this.conditionsLink = this.getSettingsValue(setting_);
				} else if (setting.startsWith('ipidtext1=')) {
					this.ipidText1 = this.getSettingsValue(setting_);
				} else if (setting.startsWith('ipidlink1=')) {
					this.ipidLink1 = this.getSettingsValue(setting_);
				} else if (setting.startsWith('conditionstext1=')) {
					this.conditionsText1 = this.getSettingsValue(setting_);
				} else if (setting.startsWith('conditionslink1=')) {
					this.conditionsLink1 = this.getSettingsValue(setting_);
				} else if (setting.startsWith('iebrowsercontent=')) {
					this.ieBrowserContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('iebrowsertitle=')) {
					this.ieBrowserTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('samlettilbudlink=')) {
					this.samletTilbudLink = this.getSettingsValue(setting_);
				} else if (setting.startsWith('samlettilbudtext=')) {
					this.samletTilbudText = this.getSettingsValue(setting_);
				} else if (setting.startsWith('defaultcalcerrortitle=')) {
					this.defaultCalcErrorTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('defaultcalcerrorcontent=')) {
					this.defaultCalcErrorContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('yearlysavings=')) {
					this.yearlySavings = this.getSettingsValue(setting_);
				} else if (setting.startsWith('existinginsurancetext=')) {
					this.existingInsuranceText = this.getSettingsValue(setting_);
				} else if (setting.startsWith('mincustomerage=')) {
					this.minCustomerAge = Number.parseInt(this.getSettingsValue(setting_));
				} else if (setting.startsWith('customeragepopuptitle=')) {
					this.customerAgePopupTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('customeragepopupcontent=')) {
					this.customerAgePopupContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('customeragepopupredirect=')) {
					this.customerAgePopupRedirect = this.getSettingsValue(setting_);
				} else if (setting.startsWith('calculatedheadline=')) {
					this.calculatedHeadline = this.getSettingsValue(setting_);
				} else if (setting.startsWith('closecalculator=')) {
					this.closeCalculator = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('closecalculatorpopuptitle=')) {
					this.closeCalculatorPopupTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('closecalculatorpopupcontent=')) {
					this.closeCalculatorPopupContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('btnlabelclose=')) {
					this.btnLabelClose = this.getSettingsValue(setting_);
				} else if (setting.startsWith('btnsecondlabelclose=')) {
					this.btnSecondLabelClose = this.getSettingsValue(setting_);
				} else if (setting.startsWith('btnsecondlabelclosestyle=')) {
					this.btnSecondLabelCloseStyle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('btnredirectclose=')) {
					this.btnRedirectClose = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('btnredirecturlclose=')) {
					this.btnRedirectUrlClose = this.getSettingsValue(setting_);
				} else if (setting.startsWith('btncallmeupenabled=')) {
					this.btnCallMeUpEnabled = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('recommendationtxt=')) {
					this.recommendationTxt = this.getSettingsValue(setting_);
				} else if (setting.startsWith('recommendationpackage=')) {
					this.recommendationPackage = this.getSettingsValue(setting_);
				} else if (setting.startsWith('recommendationpopover=')) {
					this.recommendationPopover = this.getSettingsValue(setting_);
				} else if (setting.startsWith('allcalculationproducts=')) {
					this.AllCalculationProducts = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('discountproducts=')) {
					this.discountProducts = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('=discountproductnone')) {
					this.discountProductNone = this.getSettingsValue(setting_);
				} else if (setting.startsWith('discountprimaryproducts=')) {
					this.discountPrimaryProducts = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('discountsecondaryproducts=')) {
					this.discountSecondaryProducts = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('discountternaryproducts=')) {
					this.discountTernaryProducts = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('campaigns=')) {
					this.campaignsRaw = this.getSettingsValue(setting_);
				} else if (setting.startsWith('campaignsplash=')) {
					this.campaignSplash = this.getSettingsValue(setting_);
				} else if (setting.startsWith('campaignsplashicons=')) {
					this.campaignSplashIcons = this.getSettingsValue(setting_);
				} else if (setting.startsWith('campaignsplashdependentactive=')) {
					this.campaignSplashDependentActive = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('campaignsplashdependentproducts=')) {
					this.campaignSplashDependentProducts = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('campaignsplashminproductsbasket=')) {
					this.campaignSplashMinProductsBasket = Number.parseInt(this.getSettingsValue(setting_));
				} else if (setting.startsWith('campaignsplashalerttitle=')) {
					this.campaignSplashAlertTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('campaignsplashalertcontent=')) {
					this.campaignSplashAlertContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('campaignsplashalerttitleactivate=')) {
					this.campaignSplashAlertTitleActivate = this.getSettingsValue(setting_);
				} else if (setting.startsWith('campaignsplashalertcontentactivate=')) {
					this.campaignSplashAlertContentActivate = this.getSettingsValue(setting_);
				} else if (setting.startsWith('pluscustomernodiscount=')) {
					this.plusCustomerNoDiscount = this.getSettingsValue(setting_);
				} else if (setting.startsWith('pluscustomernodiscountnocampaigndiscount=')) {
					this.plusCustomerNoDiscountNoCampaignDiscount = this.getSettingsValue(setting_);
				} else if (setting.startsWith('pluscustomerdiscount=')) {
					this.plusCustomerDiscount = this.getSettingsValue(setting_);
				} else if (setting.startsWith('pluscustomerpopover=')) {
					this.plusCustomerPopover = this.getSettingsValue(setting_);
				} else if (setting.startsWith('calculationinvalid=')) {
					this.calculationInvalid = this.getSettingsValue(setting_);
				} else if (setting.startsWith('calculationnotdone=')) {
					this.calculationNotDone = this.getSettingsValue(setting_);
				} else if (setting.startsWith('showbasket=')) {
					this.showBasket = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('addproductstxt=')) {
					this.addProductsTxt = this.getSettingsValue(setting_);
				} else if (setting.startsWith('btninlinelabel=')) {
					this.btnInlineLabel = this.getSettingsValue(setting_);
				} else if (setting.startsWith('btninlinestyle=')) {
					this.btnInlineStyle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('btninlinefaillabel=')) {
					this.btnInlineFailLabel = this.getSettingsValue(setting_);
				} else if (setting.startsWith('btninlinefailstyle=')) {
					this.btnInlineFailStyle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('btninlineicon=')) {
					this.btnInlineIcon = this.getSettingsValue(setting_);
				} else if (setting.startsWith('usebtninlinefail=')) {
					this.useBtnInlineFail = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('coveragegroups=')) {
					this.coverageGroups = this.getSettingsValue(setting_);
				} else if (setting.startsWith('coveragegroupdescriptions=')) {
					this.coverageGroupDescriptions = this.getSettingsValue(setting_);
				} else if (setting.startsWith('coveragegroupssubfeatures=')) {
					this.coverageGroupsSubFeatures = this.getSettingsValue(setting_);
				} else if (setting.startsWith('pluscustomercalculation=')) {
					this.plusCustomerCalculation = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('mockdata=')) {
					if (isDevelop) {
						this.mockData = JSON.parse(this.getSettingsValue(setting_));
						if (!this.mockData && store.state.doMock) {
							information('Overriding mockdata develop to true');
							this.mockData = true;
						}
					} else {
						this.mockData = false;
					}
				} else if (setting.startsWith('selvrisikolabel=')) {
					this.selvrisikoLabel = this.getSettingsValue(setting_);
				} else if (setting.startsWith('packagesubheader=')) {
					this.packageSubheader = this.getSettingsValue(setting_);
				} else if (setting.startsWith('suggestproductstext=')) {
					this.suggestProductsText = this.getSettingsValue(setting_);
				} else if (setting.startsWith('suggestproductstext1=')) {
					this.suggestProductsText1 = this.getSettingsValue(setting_);
				} else if (setting.startsWith('suggesttextminibasket=')) {
					this.suggestTextMiniBasket = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('minibasketdiscountpretxt=')) {
					this.miniBasketDiscountPreTxt = this.getSettingsValue(setting_);
				} else if (setting.startsWith('minibasketdiscountposttxt=')) {
					this.miniBasketDiscountPostTxt = this.getSettingsValue(setting_);
				} else if (setting.startsWith('extendcoverages=')) {
					this.extendCoverages = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('campaignstorevalidmillis=')) {
					this.campaignStoreValidMillis = Number.parseInt(this.getSettingsValue(setting_));
				} else if (setting.startsWith('overviewshowyearlyprice=')) {
					this.overviewShowYearlyPrice = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('tryloadcustomer=')) {
					this.tryLoadCustomer = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('receiptopentxt=')) {
					this.receiptOpenTxt = this.getSettingsValue(setting_);
				} else if (setting.startsWith('receiptclosedtxt=')) {
					this.receiptClosedTxt = this.getSettingsValue(setting_);
				} else if (setting.startsWith('receiptonetxt=')) {
					this.receiptOneTxt = this.getSettingsValue(setting_);
				} else if (setting.startsWith('receiptbaskettxt=')) {
					this.receiptBasketTxt = this.getSettingsValue(setting_);
				} else if (setting.startsWith('receiptopenmissingproduct=')) {
					this.receiptOpenMissingProduct = this.getSettingsValue(setting_);
				} else if (setting.startsWith('receiptclosedmissingproduct=')) {
					this.receiptClosedMissingProduct = this.getSettingsValue(setting_);
				} else if (setting.startsWith('receipttxtend=')) {
					this.receiptTxtEnd = this.getSettingsValue(setting_);
				} else if (setting.startsWith('mailconfirmationtoteam=')) {
					this.mailConfirmationToTeam = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('badge=')) {
					this.badge = this.getSettingsValue(setting_);
				} else if (setting.startsWith('callupaddresses=')) {
					this.mapAdresses(this.getSettingsValue(setting_).toLocaleLowerCase());
				} else if (setting.startsWith('callupaddressespopuptitle=')) {
					this.callupAddressesPopupTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('callupaddressespopupcontent=')) {
					this.callupAddressesPopupContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('queryproductnames=')) {
					this.queryProductNames = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('queryproductvalues=')) {
					this.queryProductValues = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('addresssupplement=')) {
					this.addressSupplement = Number.parseFloat(this.getSettingsValue(setting_));
				} else if (setting.startsWith('shorttitle=')) {
					this.shortTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('shortmaintitle=')) {
					this.shortMainTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('wrongaddresspopuptitle=')) {
					this.wrongAddressPopuptitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('wrongaddresspopupcontent=')) {
					this.wrongAddressPopupContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('hasglobalmessage=')) {
					this.hasGlobalMessage = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('globalmessagetxt=')) {
					this.globalMessageTxt = this.getSettingsValue(setting_);
				} else if (setting.startsWith('globalmessagedate=')) {
					this.globalMessageDate = this.getSettingsValue(setting_);
				} else if (setting.startsWith('globalmessagefrom=')) {
					this.globalMessageFrom = this.getSettingsValue(setting_);
				} else if (setting.startsWith('globalmessageto=')) {
					this.globalMessageTo = this.getSettingsValue(setting_);
				} else if (setting.startsWith('globalmessagetimeout=')) {
					this.globalMessageTimeout = Number.parseInt(this.getSettingsValue(setting_));
				} else if (setting.startsWith('uselocalstorage=')) {
					this.useLocalStorage = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('globalmessagemultipledates=')) {
					this.globalMessageMultipleDates = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('closingdaysforcall=')) {
					this.closingDaysForCall = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('openforcall=')) {
					this.openForCall = this.getSettingsValue(setting_);
				} else if (setting.startsWith('contacttextnocall=')) {
					this.contactTextNoCall = this.getSettingsValue(setting_);
				} else if (setting.startsWith('calculatorconfigid=')) {
					this.calculatorConfigId = this.getSettingsValue(setting_);
				} else if (setting.startsWith('sendleadmail=')) {
					this.sendLeadMail = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('phonenopopover=')) {
					this.phoneNoPopOver = this.getSettingsValue(setting_);
				} else if (setting.startsWith('selvrisikopopover=')) {
					this.selvrisikoPopover = this.getSettingsValue(setting_);
				} else if (setting.startsWith('usenewpolicyapi=')) {
					this.useNewPolicyAPI = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('logtoappuitest=')) {
					this.logToAppUiTest = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('sendproposaltoemail=')) {
					this.sendProposalToEmail = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('sendproposaltosalesforce=')) {
					this.sendProposalToSalesForce = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('salesforcetimeout=')) {
					this.salesForceTimeout = Number.parseInt(this.getSettingsValue(setting_));
				} else if (setting.startsWith('usesalesforcequoteapi=')) {
					this.useSalesForceQuoteApi = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('customeraddressrequired=')) {
					this.customerAddressRequired = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('salesforcetesturi=')) {
					this.salesForceTestUri = this.getSettingsValue(setting_);
				} else if (setting.startsWith('salesforcetestenvironmentheader=')) {
					this.salesForceTestEnvironmentHeader = this.getSettingsValue(setting_);
				} else if (setting.startsWith('showyearlyprices=')) {
					this.showYearlyPrices = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('regnopopover=')) {
					this.regNoPopover = this.getSettingsValue(setting_);
				} else if (setting.startsWith('accountnopopover=')) {
					this.accountNoPopover = this.getSettingsValue(setting_);
				} else if (setting.startsWith('skipaccountinfo=')) {
					this.skipAccountInfo = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('campaignproductsupsale=')) {
					this.campaignProductsUpSale = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('upsaleshowproductsafterpk3=')) {
					this.upsaleShowProductsAfterPK3 = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('showupsaledetailblock=')) {
					this.showUpsaleDetailBlock = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('secondarysuggestorderupsale=')) {
					this.secondarySuggestOrderUpSale = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('upsalealertdiscounttitle=')) {
					this.upsaleAlertDiscountTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('upsalealertdiscountcontent=')) {
					this.upsaleAlertDiscountContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('multiplepkstartbtnupsale=')) {
					this.multiplePkStartBtnUpSale = this.getSettingsValue(setting_);
				} else if (setting.startsWith('maintxtupsale=')) {
					this.mainTxtUpSale = this.getSettingsValue(setting_);
				} else if (setting.startsWith('maintxtupsalemorediscount=')) {
					this.mainTxtUpSaleMoreDiscount = this.getSettingsValue(setting_);
				} else if (setting.startsWith('txtproductupsale=')) {
					this.txtProductUpSale = this.getSettingsValue(setting_);
				} else if (setting.startsWith('productamounttxtupsale=')) {
					this.productAmountTxtUpSale = this.getSettingsValue(setting_);
				} else if (setting.startsWith('producttotalamounttxtupsale=')) {
					this.productTotalAmountTxtUpSale = this.getSettingsValue(setting_);
				} else if (setting.startsWith('producttotalamountnumberupsale=')) {
					this.productTotalAmountNumberUpSale = this.getSettingsValue(setting_);
				} else if (setting.startsWith('toggletitleclosedupsale=')) {
					this.toggleTitleClosedUpSale = this.getSettingsValue(setting_);
				} else if (setting.startsWith('toggletitleopenupsale=')) {
					this.toggleTitleOpenUpSale = this.getSettingsValue(setting_);
				} else if (setting.startsWith('btnlabelupsale=')) {
					this.btnLabelUpSale = this.getSettingsValue(setting_);
				} else if (setting.startsWith('notcalculatedupsaleproduct=')) {
					this.notCalculatedUpSaleProduct = this.getSettingsValue(setting_);
				} else if (setting.startsWith('singleproducttxtupsale=')) {
					this.singleProductTxtUpSale = this.getSettingsValue(setting_);
				} else if (setting.startsWith('consentcprtext=')) {
					this.consentCprText = this.getSettingsValue(setting_);
				} else if (setting.startsWith('consenttextnocompany=')) {
					this.consentTextNoCompany = this.getSettingsValue(setting_);
				} else if (setting.startsWith('consenttext=')) {
					this.consentText = this.getSettingsValue(setting_);
				} else if (setting.startsWith('consentlinktext=')) {
					this.consentLinkText = this.getSettingsValue(setting_);
				} else if (setting.startsWith('consentdetailstext=')) {
					this.consentDetailsText = this.getSettingsValue(setting_);
				} else if (setting.startsWith('focusfirstfielddesktop=')) {
					this.focusFirstFieldDesktop = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('updateexcesslistfromproductcalculation=')) {
					this.updateExcessListFromProductCalculation = JSON.parse(this.getSettingsValue(setting_));
				}
			});
		} catch (e) {
			exception(e);
		}
	}
	public getSettingsValue(setting: string): any {
		return setting.substring(setting.indexOf('=') + 1, setting.length);
	}

	/**Map addresses to object searchable tree */
	public mapAdresses(callUpAdressesRaw: string): void {
		if (callUpAdressesRaw) {
			const zips: string[] = callUpAdressesRaw.split('¤');
			zips.map((zip) => zip.trim());

			zips.forEach((addressBlock) => {
				let block = addressBlock.split('_').map((elem) => elem.trim());
				const zipCity = block[0];

				// remove zipCity
				block = block.filter((element) => element !== zipCity);

				const streets: Array<Street> = [];

				block.forEach((element) => {
					const street = element.split(':').map((elem) => elem.trim());
					const name = street[0];
					// remove name
					const nos = street[1];

					streets.push({
						name,
						nos: nos ? nos.split(',').map((elem) => elem.trim()) : undefined,
					});
				});
				this.callUpAddressesBlocks.push({
					zipCity,
					streets,
				});
			});
		}
	}

	private setCoverageGroups() {
		if (this.coverageGroups && this.coverageGroupsSubFeatures) {
			const groups: string[] = this.coverageGroups.split('¤');
			const subGroup: string[] = this.coverageGroupsSubFeatures.split('_');
			this.coverageGrouping = new Map();
			this.allSubFeatures = [];
			groups.forEach((group, inx) => {
				const subFeatures = subGroup[inx].split('¤');
				this.coverageGrouping.set(group, subFeatures);
				this.allSubFeatures = this.allSubFeatures.concat(subFeatures);
			});
		}
	}

	public mapCoverageGroups(coverages: Array<any>): void {
		if (this.coverageGroups && this.coverageGroupsSubFeatures) {
			const groupedCovs: Map<string, string> = new Map();
			this.coverageGrouping.forEach((features, name) => {
				groupedCovs.set(name, undefined);
			});
			let removeCoverages: Array<number> = [];
			if (this.coverageGrouping) {
				coverages.forEach((cov, inx) => {
					const name = cov.name ?? cov.title;
					if (this.allSubFeatures.includes(name)) {
						this.coverageGrouping.forEach((features, group) => {
							if (features.includes(name)) {
								let subFeatures = groupedCovs.get(group);
								if (!subFeatures) {
									subFeatures = '<ul class="subfeature_description">';
								}
								subFeatures += `<li><b>${name}</b><br>${cov.description}</li>`;
								groupedCovs.set(group, subFeatures);
								removeCoverages.push(inx);
							}
						});
					}
				});
			}
			removeCoverages = removeCoverages.reverse();
			removeCoverages.forEach((remove) => {
				coverages.splice(remove, 1);
			});

			let inx = 0;
			const groupDesc = this.coverageGroupDescriptions.split('¤');
			groupedCovs.forEach((description, name) => {
				if (description) {
					const cov = new Coverage(name, name, name, groupDesc[inx] + description + '</ul>');
					coverages.unshift(cov);
				}
				inx++;
			});
		}
	}
}
